import { AppWindow } from '@app/entities/app-window';
import { isActiveMobileInterface } from '@app/modules/core/mappers/mobile-interface.mapper';
import { isNullOrUndefined } from '@app/util/util';
import { environment as ENV } from '@environment';

declare const window: AppWindow;

export function stopPropagation(): void {
  if (typeof window === 'undefined') {
    return;
  }
}

export function goToSupportHelper(): void {
  stopPropagation();
  window.open(ENV.store_configuration.SUPPORT_LINK, '_self');
}

export function goToWhatsappSupportHelper(text?: string | undefined): void {
  stopPropagation();
  if (isActiveMobileInterface()) {
    const WHATSAPP_SUPPORT_APP_LINK = text ?
      `${ENV.store_configuration.WHATSAPP_SUPPORT_APP_LINK}&text=${text}` : ENV.store_configuration.WHATSAPP_SUPPORT_APP_LINK;
    window.open(WHATSAPP_SUPPORT_APP_LINK, '_self');
  } else {
    const WHATSAPP_SUPPORT_LINK = text ?
      `${ENV.store_configuration.WHATSAPP_SUPPORT_LINK}?text=${text}` : ENV.store_configuration.WHATSAPP_SUPPORT_LINK;
    window.open(WHATSAPP_SUPPORT_LINK, '_blank');
  }
}

export function goToUrlHelper(url: string): void {
  stopPropagation();
  if (isActiveMobileInterface()) {
    if (!isNullOrUndefined(window.app)) {
      window.app.openURL(url);
    } else if (!isNullOrUndefined(window.appInterface)) {
      window.appInterface.openURL(url);
    } else if (!isNullOrUndefined(window.webkit)) {
      window.webkit.messageHandlers.openURL.postMessage(url);
    }
  } else {
    window.open(url, '_blank');
  }
}
